import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionItemTemplateCategoriesApi = {
    getInstitutionItemTemplateCategories: (): Observable<Dtos.GetInstitutionItemTemplateCategoriesResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionItemTemplateCategories = new Dtos.GetInstitutionItemTemplateCategories();

        //Send request.
        const response: Promise<Dtos.GetInstitutionItemTemplateCategoriesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionItemTemplateCategoryById: (id: number): Observable<Dtos.GetInstitutionItemTemplateCategoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionItemTemplateCategoryById = new Dtos.GetInstitutionItemTemplateCategoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionItemTemplateCategoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionItemTemplateCategory: (institutionItemTemplateCategory: Dtos.InstitutionItemTemplateCategory): Observable<Dtos.SetInstitutionItemTemplateCategoryResponse> => {

        let request: Dtos.SetInstitutionItemTemplateCategory = new Dtos.SetInstitutionItemTemplateCategory();

        request.institutionItemTemplateCategory = institutionItemTemplateCategory;

        // send request
        const response: Promise<Dtos.SetInstitutionItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createInstitutionItemTemplateCategory: (): Observable<Dtos.CreateInstitutionItemTemplateCategoryResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionItemTemplateCategory = new Dtos.CreateInstitutionItemTemplateCategory();

        //Send request.
        const response: Promise<Dtos.CreateInstitutionItemTemplateCategoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateInstitutionItemTemplateCategory: (institutionItemTemplateCategory: Dtos.InstitutionItemTemplateCategory): Observable<Dtos.ValidateInstitutionItemTemplateCategoryResponse> => {

        let request: Dtos.ValidateInstitutionItemTemplateCategory = new Dtos.ValidateInstitutionItemTemplateCategory();

        request.institutionItemTemplateCategory = institutionItemTemplateCategory;

        // send request
        const response: Promise<Dtos.ValidateInstitutionItemTemplateCategoryResponse> = client.post(request);

        return Observable.from(response);

    }
}